import React, { useState } from 'react';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import Button from '../../components/bootstrap/Button';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Label from '../../components/bootstrap/forms/Label';
import OtpInput from 'react-otp-input';

const VerificationOTP = () => {
    const [otpState, setOtpState] = useState('');
    const handleChange = () => {
        setOtpState(otpState);
    };
    return (
        <React.Fragment>
            <PageWrapper title='Verification'>
                <div className='row align-items-center justify-content-center'>
                    <div className='col-xl-6 col-sm-12 left-aside'></div>
                    <div className='col-xl-6 col-sm-12 right-aside'>
                        <div className='col-xl-6'>
                            <img
                                src={require('../../assets/img/logo.png')}
                                width='50'
                                alt='Liiftsocial'
                            />
                            <h3 className='greeting-text'>
                                Verify your account
                            </h3>
                            <p className='greeting-subtext'>
                                Enter the verification OTP received on your
                                email address and proceed further with the
                                account creation.
                            </p>
                            <form className='row g-4 login-form'>
                                <div className='col-12'>
                                    <Label htmlFor='login-email'>
                                        Verification Code
                                    </Label>
                                    <OtpInput
                                        value={otpState}
                                        onChange={handleChange}
                                        numInputs={6}
                                        className='verificationOTP'
                                        separator={<span>-</span>}
                                    />
                                </div>
                                <div className='col-12 mt-4'>
                                    <div
                                        className='d-flex'
                                        style={{ justifyContent: 'left' }}>
                                        <a
                                            href='/#'
                                            className='forgot-pass-text'
                                            style={{ marginLeft: '5px' }}>
                                            Didn't recieve code?
                                        </a>
                                    </div>
                                </div>
                                <div className='col-12 mt-5'>
                                    <Button
                                        color='primary'
                                        className='w-100 py-3'>
                                        Verify
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        </React.Fragment>
    );
};

export default VerificationOTP;
